import React from 'react';

const BackgroundVideo = () => {
  return (
    <div className="background-video-container">
      <video className="background-video" autoPlay loop muted playsInline>
        <source src="/background-video1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay-content">
        {/* Add any content (like text or buttons) over the video */}
      </div>
    </div>
  );
};

export default BackgroundVideo;
